module.exports = __webpack_public_path__ + "img/big.48b11b6e.jpg";